<template>
  <div class="ppcCommentSection" style="min-width: 300px">
    <div v-if="(creative.status != 'done' && creative.comment_status == 'client' && $store.state.user.user_type == 'client') || (creative.status != 'done' && creative.comment_status == 'account' && $store.state.user.user_type != 'client') " class="commenterNameContainer">
      <div class="commentersName">{{$store.state.user.name}}</div>
      <div>
        <PPCAddComment :brand="brand" :creative="creative"/>
        
      </div>
    </div>
    
    <div class="md-scrollbar" v-if="creative.comment">
      <comment v-for="(comment, i) in main_comments" :key="i" :comment="comment" :reply="true" :index="i" :accountView="accountView"/>
        
    </div>
    <div class="need-more-info-wrap" v-if="creative.status == 'live' && creative.comment_status == 'account' && creative.comment && creative.comment.slice(-1)[0].user.user_type == 'account' && $store.state.user.user_type != 'client'">
        
        <div class="need-more-info">
          <div class="need-more-info__chb-wrap" @click="needInformation">            
            <md-checkbox  class="md-primary" @change="needInformation" >I need further information</md-checkbox>              
            <div class="info-text">If you leave the box <strong>unchecked</strong>, the commenting will not be allowed from the next round.</div>
          </div>          
        </div>
    </div>
    <div class="need-more-info-wrap " v-if="creative.status == 'live' && creative.comment_status == 'need_more_info' && $store.state.user.user_type != 'client'">
        
        <div class="need-more-info success">
          <div class="need-more-info__chb-wrap" @click="notNeedInformation">            
            <md-checkbox  class="md-primary" v-model="checked" @change="notNeedInformation">I need further information</md-checkbox>              
            <div class="info-text">If you leave the box <strong>unchecked</strong>, the commenting will not be allowed from the next round.</div>
          </div>          
        </div>
    </div>
    <div class="comment-help-text" v-if="creative.status!='done' && $store.state.user.user_type == 'account' && creative.comment_status == 'account'">
      <div>The client is not allowed to comment.</div>
      <div>Make sure to click the <br/> "<span>SEND TO CLIENT</span>" button <br/> after you're done uploading and commenting.</div>
    </div>
    <div class="comment-help-text" v-if="creative.status!='done' && $store.state.user.user_type == 'client' && creative.comment_status == 'client'">
      
      <div>Make sure to click the <br/> "<span>Done with commenting</span>" button <br/> after you're done commenting on the board.</div>
    </div>
    
    
  </div>
</template>

<script>
import PPCAddComment from "./PPCAddComment";
import comment from "./message";

export default {
  props:['creative','brand','board','accountView'],
  data(){
    return {
      checked : true
    }
  },
  components: {PPCAddComment,comment},
  computed:{
    main_comments(){
      //console.log('filter',this.creative.comment.filter(comment => comment.reply_to == 0));
      return this.creative.comment.filter(comment => comment.reply_to == 0)
    }
  },
  methods: {
    needInformation(){
      var _this = this;
      _this.put('creative/' + this.creative.id, {status: 'live', board_id: this.board.id ,'comment_status': 'need_more_info'}, {}, function () {
        if (_this.$parent.refreshBoard)
          _this.$parent.refreshBoard()
          _this.checked = true;
      })
    },
    notNeedInformation(){
      var _this = this;
      _this.put('creative/' + this.creative.id, {status: 'live', board_id: this.board.id, 'comment_status': 'account'}, {}, function () {
        if (_this.$parent.refreshBoard)
          _this.$parent.refreshBoard();
          _this.checked = false;
      })
    },
    refreshBoard(){
       if (this.$parent.refreshBoard)
            this.$parent.refreshBoard();
    },
  },
};
</script>
